import { render, staticRenderFns } from "./ShopGiveConfig.vue?vue&type=template&id=e37bf5ee&scoped=true&"
import script from "./ShopGiveConfig.vue?vue&type=script&lang=js&"
export * from "./ShopGiveConfig.vue?vue&type=script&lang=js&"
import style0 from "./ShopGiveConfig.vue?vue&type=style&index=0&id=e37bf5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37bf5ee",
  null
  
)

export default component.exports